import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';
import * as CircuitUtils from '../../../utils/circuit';

export function computeCapacitorLimitMultipliers(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  let maxMultiplier = computeCapacitorMaximumLimitMultiplier(
    c1IdealValue,
    c2IdealValue,
    r1IdealValue,
    r2IdealValue,
    r5IdealValue,
  );
  let minMultiplier = computeCapacitorMinimumLimitMultiplier(
    c1IdealValue,
    c2IdealValue,
    r1IdealValue,
    r2IdealValue,
    r5IdealValue,
  );
  return {
    capacitorMinimumLimitMultiplier: minMultiplier,
    capacitorMaximumLimitMultiplier: maxMultiplier,
  };
}

export function computeGainResistorLimitMultipliers(r3IdealValue, r4IdealValue) {
  let minMultiplier = CircuitUtils.getResistorMinimumLimitMultiplier(r3IdealValue, r4IdealValue);
  let maxMultiplier = CircuitUtils.getResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  return {
    resistorMinimumLimitMultiplier: minMultiplier,
    resistorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  var cmax = Math.max(c1IdealValue, c2IdealValue);
  var initialcapacitorMaximumLimitMultiplier = FilterConstants.Limits.CBIG_COMP_LIMIT / cmax;
  var r1TinyTemp = r1IdealValue / initialcapacitorMaximumLimitMultiplier;
  var r2TinyTemp = r2IdealValue / initialcapacitorMaximumLimitMultiplier;
  var r5TinyTemp = r5IdealValue / initialcapacitorMaximumLimitMultiplier;
  var result = initialcapacitorMaximumLimitMultiplier;
  if (CommonUtils.parallel(r1TinyTemp, r2TinyTemp) < FilterConstants.Limits.RSMALL_LOAD_LIMIT) {
    result = (result * CommonUtils.parallel(r1TinyTemp, r2TinyTemp)) / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
    r5TinyTemp = r5IdealValue / result;
  }

  if (r5TinyTemp < FilterConstants.Limits.RSMALL_LOAD_LIMIT) {
    result = (result * r5TinyTemp) / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, c2IdealValue, r1IdealValue, r2IdealValue, r5IdealValue) {
  var cmin = Math.min(c1IdealValue, c2IdealValue);
  var r1 = r1IdealValue;
  var r2 = r2IdealValue;
  var r5 = r5IdealValue;
  var biggestR = null;

  if (CommonUtils.isNearInfinity(r2)) {
    biggestR = Math.max(r1, r5);
  } else {
    biggestR = Math.max(r1, r2, r5);
  }

  var result = FilterConstants.Limits.CSMALL_COMP_LIMIT / cmin;
  var biggestR2 = biggestR / result;
  if (biggestR2 > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    result = (result * biggestR2) / FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return result;
}
